(Symbol as any).metadata ??= Symbol('metadata');
